var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('md-whiteframe',{staticClass:"pad-32",staticStyle:{"text-align":"center"},attrs:{"md-elevation":"8"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }